import React from 'react';
import DOMPurify from 'dompurify';

interface GuidanceModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAccept: () => void;
  title: string;
  content: string;
}

const GuidanceModal: React.FC<GuidanceModalProps> = ({ 
  isOpen, 
  onClose, 
  onAccept, 
  title,
  content
}) => {
  if (!isOpen) {
    return null;
  }

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  // Check if this is a supporter feature modal
  const isSupporterFeature = title.includes('Supporter') || content.includes('Supporters Club');
  const isLoginRequired = title.includes('Login Required');

  const handleAccept = () => {
    if (isSupporterFeature) {
      window.location.href = '/account';
    } else {
      onAccept();
    }
  };

  return (
    <div className="modal-overlay" onClick={handleBackdropClick}>
      <div className={`modal-content ${isSupporterFeature ? 'supporter-feature-modal' : ''} ${isLoginRequired ? 'login-required-modal' : ''}`}>
        <div className="modal-header">
          <h2 className="modal-title">{title}</h2>
          <button className="modal-close" onClick={onClose}>
            ×
          </button>
        </div>
        
        <div className="modal-body">
          <div className="modal-content-text" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content, {
            ALLOWED_TAGS: ['br', 'b', 'i', 'strong', 'em', 'p', 'ul', 'li', 'span'],
            ALLOWED_ATTR: ['class']
          }) }} />
          
          
          {isLoginRequired && (
            <div className="login-benefits">
              <h3>🔐 Create Your Free Account:</h3>
              <ul>
                <li>💾 Save unlimited scenarios</li>
                <li>📱 Access from any device</li>
                <li>📊 Track your financial journey</li>
                <li>🎯 Personalized recommendations</li>
                <li>⭐ Upgrade to Supporter anytime</li>
              </ul>
            </div>
          )}
        </div>
        
        <div className="modal-footer">
          <button className="modal-button modal-button-secondary" onClick={onClose}>
            Close
          </button>
          <button className="modal-button modal-button-primary" onClick={handleAccept}>
            {isSupporterFeature ? 'More Info' : (isLoginRequired ? 'Get Started' : 'Got it!')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default GuidanceModal; 